import { Injectable } from '@angular/core';
import { Content, ImageListResponse } from '../types/ws-select-image';
import { ImageSelectResource } from '../resources/image-select.resource';

@Injectable()
export class ImageSelectService {
	private _imageFiles: Content[] = [];

	constructor(private imageSelectResource: ImageSelectResource) {
		/*this.fetchImages();*/
	}

	public fetchImages(): void {
		this.imageSelectResource.get({ mime: 'image' }).then((res) => {
			const body = res.body;

			if (body?.content) {
				this._imageFiles = body.content;
				this._imageFiles.map((i) => i._id);
			}
		});
	}

	get imageObjects(): Content[] {
		return this._imageFiles || [];
	}
}
